import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../EmptyFragment';
import { T } from '../../../../../../Translations';

interface Props {
  title: string;
  featured: Maybe<Date>;
}

function Heading({ title, featured }: Props) {
  return (
    <div className="mb-6 flex items-center">
      <h1 className="py-1 text-xl font-medium">{title}</h1>
      {featured
        .map(() => (
          <p className="ml-2 h-fit rounded-md bg-[#86198F] px-2 py-1 text-xs text-white">
            <T kind="Trending" />
          </p>
        ))
        .getOrElse(emptyFragment)}
    </div>
  );
}

export default observer(Heading);
